export default {
  addRes(state) {
    return "计算结果：" + state.count;
  },
  //可不可以参会
  //未关闭，已开放，已发布 = 可参会
  //未关闭，已开放，已发布，（已登录 || 已报名），（无权限 || 已删除） = 不可参会
  //未关闭，未开放，已发布，（需登录已登录， 需要报名已报名 || 无限制观看） = 不可参会
  //会场发布，无论会场是否开放，都可登录报名；如果会场未开放，登录报名后不可参会提示会场未开放
  canJoin() {
    return;
  },
  //可不可以进入会场
  // 已登录，已报名 || 已登录 || 已报名 || 无需登录 || 无限制观看 = 可进入会场
  canEnter() {}
};
